// extracted by mini-css-extract-plugin
export var checkbox = "styles-module--checkbox--e2851";
export var checkmark = "styles-module--checkmark--b80ea";
export var disabled = "styles-module--disabled--a9b0e";
export var label = "styles-module--label--b8c41";